// index.js
import React from "react";
import ReactDOM from "react-dom/client"; // React 18
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";
import "./index.css";
import { bootstrapAuth } from "./api"; // <-- from the api.js we added earlier

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

async function start() {
  // Try to restore session (uses httpOnly cookie)
  await bootstrapAuth();

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId={clientId}>
        <App />
      </GoogleOAuthProvider>
    </React.StrictMode>
  );
}

start();
